import logoSrc from '@/assets/eshkol-galil-mizrahi-logo.png';
import styles from './EshkolLogo.module.css';

interface Props {
  className?: string;
  alt: string;
  variant?: 'default' | 'hero';
}

export function EshkolLogo({ className = '', alt, variant = 'default' }: Props) {
  const variantClass = variant === 'hero' ? styles.hero : styles.default;

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={`${styles.logo} ${variantClass} ${className}`.trim()}
      width={variant === 'hero' ? 220 : 176}
      height={variant === 'hero' ? 149 : 120}
      decoding="async"
      data-testid="landing-eshkol-logo"
    />
  );
}
